export default [
    {
        type: 1,
        icon: require('../../navbar/images/login_icon_wechat@2x.png')
    },
    {
        type: 2,
        icon: require('../../navbar/images/login_icon_qq@2x.png')
    },
    // {
    //     type: 3,
    //     icon: require('../../navbar/images/login_icon_weibo@2x.png')
    // }
]
